import { useNavigate } from 'react-router-dom';
import qs from 'query-string';

import { SearchParams, CompanySearchParams } from 'shared/generated-models';
import { SEARCH_LOADING_SIZE } from 'features/search/models';

export const useTechnographicsSearch = () => {
	const navigate = useNavigate();

	return (values: SearchParams & CompanySearchParams) => {
		const cleanParams: Record<string, any> = Object.entries(values)
			.filter(([_, v]) => (Array.isArray(v) ? v.length > 0 : v != null))
			.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

		const search = qs.stringify(
			{ ...cleanParams, size: SEARCH_LOADING_SIZE },
			{
				arrayFormat: 'bracket-separator',
				arrayFormatSeparator: ','
			}
		);

		navigate({
			pathname: '/technographics/search/results',
			search: search
		});
	};
};
